import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OktaAuthService } from 'src/app/app.service';
import { Case, Contact } from 'src/app/shared/model/itsm';
import { ErrorService } from 'src/app/shared/services/error.service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import FileSaver from 'file-saver';
import { convertDatesFormat } from '../supportdashboard/supportdashboard.component';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Utilities } from 'src/app/shared/utilities';



@Component({
  selector: 'app-supportview',
  templateUrl: './supportview.component.html',
  styleUrls: ['./supportview.component.scss']
})
export class SupportViewComponent implements OnInit {
  userObject: any;

  caseRef: string;
  case: Case;
  cases: Case[];
  caseloading: boolean;
  parentCase: Case;
  linkedCases: Case[];

  attachments;
  attachmentSuccessful: boolean;
  attachmentError: string;

  comment: string = "";
  commentSuccessful: boolean;
  postingComment: boolean;
  commentError: string;

  assetDisplay: string;
  contactDisplay: string;
  secondContactDisplay: string;
  contacts: Contact[];
  contactType: string;
  public closeResult: string;

  linkedCasesHeading: string = "Child Cases";


  isClosed: boolean;
  commentLengthCheckError: string = "Comment length exceeded 3800 characters!";
  commentLengthCheck: boolean = false;
  salesForceTicket: boolean = false;

  constructor(private route: ActivatedRoute, private itsmService: ItsmService, private errorService: ErrorService, private auth: OktaAuthService, private modalService: NgbModal) { 
   
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if(!this.caseRef) {this.caseRef = params['caseRef']}
    });
    this.auth.getUserDetails().then(val => {
      this.userObject = val;
    });

    this.caseloading = true;
    this.itsmService.case(this.caseRef)
      .then(res => {
        //Handling Parent case if it exists
        if(res.parentId){
          this.itsmService.case(res.parentId)
          .then(res1 => {
            this.linkedCasesHeading = "Parent Case"
            this.parentCase = convertDatesFormat(res1)[0]
            this.linkedCases = [this.parentCase]
          })
        }
        this.salesForceTicket = !res.caseNumber.includes("OCD")
        this.cases = convertDatesFormat(res)
        this.case = this.cases[0];
        let closedStatuses = ["Closed", "Closed as Duplicate", "Misdirected", "No fault found", "Rejected"];
        this.isClosed = (closedStatuses.indexOf(this.case.status) > -1);

        //Handling child cases if they exist
        if(this.case.childTasks.length > 0){
          this.linkedCases = this.case.childTasks
          this.linkedCasesHeading = "Child Cases"
        }
        // Contact's display value:
        this.contactDisplay = "n/a";
        if (this.case && this.case.contact) {
          this.contactDisplay = this.case.contact.fullName;
          if (this.case.contact.email) {
            this.contactDisplay = this.contactDisplay + " - " + this.case.contact.email;
          } else {
            this.itsmService.getCachedContacts().then(contacts => {
              this.contacts = contacts;
              let contact = contacts.find(c => c.id == this.case.contact.id);
              if (contact) {
                this.contactDisplay = contact.fullName;
                if (contact.email) {
                  this.contactDisplay = this.contactDisplay + " - " + contact.email;
                }
              }
            });
          }
        }

        this.secondContactDisplay = "n/a";
        if (this.case && this.case.secondContact) {
          this.secondContactDisplay = this.case.secondContact.fullName;
          if (this.case.secondContact.email) {
            this.secondContactDisplay = this.secondContactDisplay + " - " + this.case.secondContact.email;
          } else {
            this.itsmService.getCachedContacts().then(contacts => {
              this.contacts = contacts;
              let secondcontact = contacts.find(c => c.id == this.case.secondContact.id);
              if (secondcontact) {
                this.secondContactDisplay = secondcontact.fullName;
                if (secondcontact.email) {
                  this.secondContactDisplay = this.secondContactDisplay + " - " + secondcontact.email;
                }
              }
            });
          }
        }

        // Asset's display value:
        this.assetDisplay = "n/a"
        if (this.case.asset) {
          if (this.case.asset.id) {
            this.itsmService.getCachedAssets().then(assets => {
            let asset = assets.find(c => c.id == this.case.asset.id);
              if (asset) {
                this.assetDisplay = asset.fullName;
              }
            });
          } else {
            this.assetDisplay = this.case.asset.name;
          }
        }

        this.processComments();

        this.attachments = this.case["attachments"]
        this.caseloading = false;
      })
      .catch(err => {
        this.errorService.handlerError(err);
        this.caseloading = false;
      });

  }
  processComments(){
    this.case.comments.forEach(c => {
      if(!c.creatorName || (c.creatorName === "APIPortal") || (c.creatorName === "APIPortalUK") || (c.creatorName === "GlobalPortal") || (c.creatorName === "Global customer portal")) {
        if(c.commentBody.includes('Comment created by ')){
          c.creatorName = c.commentBody.substring(c.commentBody.indexOf('Comment created by ')+'Comment created by '.length, c.commentBody.indexOf(' via customer portal'));
        }else{
          c.creatorName = 'Unknown'
        }
      }
      if(c.commentBody.includes('--------------- Original Message ---------------')){
        c.commentBody = c.commentBody.substring(0,c.commentBody.indexOf('--------------- Original Message ---------------'));
      }
       
      c.commentBody = c.commentBody.replace(/&lt;.+?\S&gt;/gm, '')
    });

    this.case.comments.sort((c1, c2) => (c1.createdDate > c2.createdDate) ? 1 : -1);
  }
  reloadPage(id){
    this.caseRef = id;
    this.ngOnInit()
  }
  postComment(silentUpdate = false){
    this.commentLengthCheck = false;
    if(this.comment?.length>3800 && this.salesForceTicket){
      this.commentLengthCheck = true;
      return false;
    }
    else if(this.comment?.length > 0 ){
      this.comment = Utilities.getStringXSSEncoded(this.comment)
      this.postingComment = true;

      let commentPostObj = {
        parentId: this.case.id, 
        commentBody: this.comment,
        user: this.userObject.email,
        silentUpdate: silentUpdate
      }
      this.itsmService.caseComment(commentPostObj)
        .then(res => {
          if(res?.map.success){
            // reload case
            this.itsmService.case(this.caseRef)
              .then(res => {
                this.comment = "";
                this.cases = convertDatesFormat(res)
                this.case = this.cases[0];
                this.postingComment = false;
                this.commentSuccessful = true;
                setTimeout(()=>{    
                  delete this.commentSuccessful;
                },3000);
                this.processComments();
              })
              .catch(err => {
                this.postingComment = false;
                this.errorService.handlerError(err);
              });
          }else{
            this.commentError = res.map.errors[0];
            this.commentSuccessful = false;
            this.postingComment = false;
          }
          
        })
      }
    
  }

  setContact() {
    if(this.contactType === "secondContact") {
      this.case.secondContactId = this.case.contactId;
      delete this.case['contactId'];
    }
    this.itsmService.caseUpdate(this.case)
         .then(res => {
           this.ngOnInit();
         })
         .catch(err => {
          this.errorService.handlerError(err);
         });

  }

  refreshAttachments(message) {
    if(message === "Successful"){
      this.attachmentSuccessful = true;
    }else{
      this.attachmentSuccessful = false;
      this.attachmentError = message;
    }
    this.itsmService.case(this.caseRef)
      .then(res => {
        this.cases = convertDatesFormat(res)
        this.case = this.cases[0];
        this.attachments = this.case["attachments"];
      })
      .catch(err => {
        this.errorService.handlerError(err);
        this.attachmentSuccessful = false;
      });

  }

  downloadAttachment(attachmentid: string, fileName: string, caseId: string) {
    this.itsmService.getAttachment(attachmentid, caseId)
      .then(res => {
        var file = new Blob([res], {type: res.type});
        FileSaver.saveAs(file, fileName);
      })
      .catch(res => {
        console.log("An error occurred trying to download file", "Error!");
      });
  }

  public open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

      if(result == 'save'){
        this.setContact();
      }

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}
